import React from 'react'
import TourneyOverview from './TourneyOverview'
import TourneyDetails from './TourneyDetails'
import Clubs from './Clubs'
import Sponsors from './Sponors'
import Social from './Social'
import Standings from './Standings'
import Register from './Register'
import Ads from './Ads'
import BigFish from './BigFish'
import {config} from '../config'
import Header from './Header'
import PrimaryButton from './PrimaryButton'
import SecondaryButton from './SecondaryButton'
import { useTournamentDetails } from '../hooks/useTournamentDetails'

import '../App.css';

const txdomain = config()['tourneyx-url']

/*Naveen 09/jan/2024-rules pdf issue . path from linode */
const linode_url_only = config()['linode-url']

const SlamTournament = (props) => {
  const tournamentId = props.match.params.tournamentId
  const tournamentDetails = useTournamentDetails(tournamentId)

  const initialState = {
    slamResults : [],
    nonSlamResults : [],
    results : [],
    errors : []
  }

  const reducer = (state, event) => {
    switch(event.type) {
      case 'SlamResultsUpdated' : return {...state, slamResults : event.slamResults}
      case 'NonSlamResultsUpdated' : return {...state, slamResults : event.nonSlamResults}
      case 'ResultsUpdated' : return {...state, slamResults : event.results}
      case 'ResultsCreated' : return {...state, slamResults : event.slamResults, nonSlamResults : event.nonSlamResults}
      case 'GetStandingsFailed' : return {...initialState, errors : [event.error]}
    }
  }

  // const seperateStandings = (standings) => {
  //   const fishTypes = tournamentDetails.fish_types
  //   const slamAnglers = standings.results[0].filter(anglerResults => {
  //     const typesFound = fishTypes.map(fishType => specieanglerResults.submissions.includes(submission.fish_type === fishType))
  //     return typesFound.includes(false) ? false : true
  //   })

  //   const slamResults = results.filter(days => {

  //   })
  // }

  // useEffect(() => {
  //   //todo get standings and seperate
  //   txApi.getStandings(tournamentId)
  //   .then(standings => seperateStandings(standings))
  //   .catch(error => {
  //     console.error(`Error loading slam standings for tourney ${tournamentId}: ${error}`)
  //     setStandings([])
  //   })

  // }, [])

  return (
    <>
    <div>
      <Header/>
    </div>
    {
      (!tournamentDetails.tournamentId) 
        ? <div></div>
        : <div>
            <div className="wrapper">  
              <div className=' section-title'>
                <h2>{tournamentDetails.tournament_title ? tournamentDetails.tournament_title : ''}</h2>
              </div>
              
              <div className=" tourney-border tourney-left">
                <TourneyDetails tournamentDetails={tournamentDetails} />
                <Register tournamentDetails={tournamentDetails}/>
                {
                  (tournamentDetails && tournamentDetails.show_standings === '0')
                    ? <div className='no-standings-standings-only'><h3>The Tournament is currently OFFLINE pending Final Results.</h3></div>
                    : <Standings details={tournamentDetails} tournamentId={tournamentId} />
                }        
              </div>
              <div className="tourney-right">
                <Social />
                <PrimaryButton href={`${txdomain.replace('https://', 'https://live.')}/?id=${tournamentId}`} text='TOURNEYX LIVE LEADERBOARD' />
                <BigFish tournamentId={tournamentId} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit}/>
                <TourneyOverview tournamentDetails={tournamentDetails} />
                <Clubs {...tournamentDetails} />
                <Sponsors {...tournamentDetails} />

                {tournamentDetails.rules ?
                <SecondaryButton href={`${linode_url_only}/rules/${tournamentDetails.rules}`} text='View Rules'/>
                : null}
                 {tournamentDetails.terms ?
                <SecondaryButton href={`${linode_url_only}/terms/${tournamentDetails.terms}`} text='View Terms &amp; Conditions'/>
                : null}

                {tournamentDetails.maps ?
                <SecondaryButton href={`${linode_url_only}/maps/${tournamentDetails.maps}`} text='Launch Maps'/>
                : null}

                <Register tournamentDetails={tournamentDetails}	/>
                <Ads ads={tournamentDetails.ads} />
              </div>
            </div>
        </div>
    }
    </>
  )
}

export default SlamTournament